import AnalyticsPageTitle from "./AnalyticsPageTitle";
import { AppHubCard } from "./AppHubCard";
import { AppHubPage } from "./AppHubPage";
import { AppListActionButton, AppListToolbar } from "./AppListToolbar";
import { AppPageHeader } from "./AppPageHeader";
import { AppPageLayout } from "./AppPageLayout";
import Call from "./Call";
import ChevronButton from "./ChevronButton";
import DeleteButton from "./DeleteButton";
import Description from "./Description";
import EditButton from "./EditButton";
import EditDialog from "./EditDialog";
import EditRow from "./EditRow";
import FooterButtons from "./FooterButtons";
import Group from "./Group";
import IconDetail from "./IconDetail";
import { LogoCard } from "./LogoCard";
import { LogoUploader } from "./LogoUploader";
import Or from "./Or";
import PhonePreview from "./PhonePreview";
import Spinner from "./Spinner";
import Stepper from "./Stepper";
import Subtitle from "./Subtitle";
import Title from "./Title";

export const commonComponents = {
    AppHubCard,
    AppHubPage,
    AppListActionButton,
    AppListToolbar,
    AppPageHeader,
    AppPageLayout,
    Or,
    ChevronButton,
    PhonePreview,
    Title,
    AnalyticsPageTitle,
    Description,
    Group,
    EditRow,
    EditDialog,
    DeleteButton,
    Call,
    FooterButtons,
    EditButton,
    IconDetail,
    Stepper,
    Subtitle,
    Spinner,
    LogoUploader,
    LogoCard,
};
